var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Profile Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xfvhd53ppa",
    x1: 1.047,
    y1: 0.5,
    x2: -1.311,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c37tcrt1nb",
    x1: 0.5,
    y1: 0.336,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#fe4600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e51400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4nkqvcetnc",
    x1: 0.5,
    y1: 0.314,
    x2: 0.884,
    y2: 1.223,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rd3a2tbzld",
    x1: 0.548,
    y1: -0.622,
    x2: 0.538,
    y2: 0.209,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f1177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 32,
    cy: 32,
    r: 32,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 155",
    transform: "translate(19 17.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 180",
    width: 6.598,
    height: 2.034,
    rx: 1.017,
    transform: "translate(3.395 9.316)",
    style: {
      fill: "url(#xfvhd53ppa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 184",
    width: 6.598,
    height: 2.034,
    rx: 1.017,
    transform: "translate(3.395 4.903)",
    style: {
      fill: "url(#xfvhd53ppa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 181",
    width: 13.359,
    height: 2.034,
    rx: 1.017,
    transform: "translate(3.395 13.728)",
    style: {
      fill: "url(#xfvhd53ppa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 183",
    width: 12.399,
    height: 2.034,
    rx: 1.017,
    transform: "translate(3.395 18.14)",
    style: {
      fill: "url(#xfvhd53ppa)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72",
    d: "M18.66 25.575H.96a.96.96 0 0 1-.96-.96V.96A.96.96 0 0 1 .96 0h11.515a.96.96 0 0 1 .959.96v4.782l5.238.065a.96.96 0 0 1 .948.959v17.849a.96.96 0 0 1-.96.96zM1.919 23.656H17.7V7.713l-5.238-.064a.96.96 0 0 1-.948-.959V1.919h-9.6z",
    style: {
      fill: "url(#c37tcrt1nb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7",
    d: "M.929 1.475a.956.956 0 0 1-.654-.257l-5.969-5.556a.96.96 0 0 1-.049-1.356.96.96 0 0 1 1.356-.049l5.97 5.556a.96.96 0 0 1-.654 1.662z",
    transform: "translate(17.742 6.159)",
    style: {
      fill: "#ff4800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 73",
    d: "M12.422 2.165v4.221h5.432z",
    transform: "translate(.279 .049)",
    style: {
      fill: "#ff4800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "M6.149 42.869a13.262 13.262 0 0 0 6.149-1.5c-.538-6.109-2.659-10.676-6.149-10.736C2.6 30.569.538 35.258 0 41.367a13.262 13.262 0 0 0 6.149 1.5",
    transform: "translate(13.059 -14.922)",
    style: {
      fill: "url(#4nkqvcetnc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58",
    d: "M6.149 42.869a13.262 13.262 0 0 0 6.149-1.5c-.538-6.109-2.659-10.676-6.149-10.736C2.6 30.569.538 35.258 0 41.367a13.262 13.262 0 0 0 6.149 1.5",
    transform: "translate(13.059 -14.922)",
    style: {
      fill: "url(#rd3a2tbzld)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M18.518 3.693A3.693 3.693 0 1 1 14.825 0a3.693 3.693 0 0 1 3.693 3.693",
    transform: "translate(4.383 8.951)",
    style: {
      fill: "#0379a0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.9de02641b84f5afddd01b5b1aef069ca.svg";
export { ForwardRef as ReactComponent };